exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2tl_70_tYsjx1uo4fXDmgL{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] ._2tl_70_tYsjx1uo4fXDmgL{border-width:1px;border-style:solid;padding:0 4px;background:\"[theme:neutralTertiary, default:#a19f9d]\"}html[dir=ltr] ._2tl_70_tYsjx1uo4fXDmgL{left:0}html[dir=rtl] ._2tl_70_tYsjx1uo4fXDmgL{right:0}html[dir=ltr] .EUw9R1C-lQN9p9eqWBXU{margin-right:-6px}html[dir=rtl] .EUw9R1C-lQN9p9eqWBXU{margin-left:-6px}", ""]);
// Exports
exports.locals = {
	"dragHelperStyle": "_2tl_70_tYsjx1uo4fXDmgL",
	"favoriteButton": "EUw9R1C-lQN9p9eqWBXU"
};